import { User } from "firebase/auth";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./Firebase";

export type CheckoutContact = {
    name: string;
    email: string;
    termsAccepted: boolean;
};

export type EnrollmentKind = "internship" | "workshop" | "mock_interview" | "program";

export async function loadCheckoutContact(user: User): Promise<CheckoutContact> {
    const snapshot = await getDoc(doc(db, "users", user.uid));
    const profile = snapshot.data() || {};
    return {
        name: String(profile.name || user.displayName || "").trim(),
        email: String(profile.email || user.email || "").trim(),
        termsAccepted: false,
    };
}

export function checkoutContactError(contact: CheckoutContact) {
    if (!contact.name.trim()) return "Enter your full name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email.trim())) return "Enter a valid email address.";
    if (!contact.termsAccepted) return "Accept the Terms and Privacy Policy to continue.";
    return "";
}

export async function saveCheckoutContact(user: User, contact: CheckoutContact) {
    const parts = contact.name.trim().split(/\s+/).filter(Boolean);
    await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        name: contact.name.trim(),
        firstName: parts[0] || "",
        lastName: parts.slice(1).join(" "),
        email: contact.email.trim().toLowerCase(),
        termsAcceptedAt: serverTimestamp(),
        checkoutContactUpdatedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    }, { merge: true });
}

export function enrollmentSuccessUrl(input: {
    kind: EnrollmentKind;
    title: string;
    id: string;
    start?: string;
    end?: string;
    paid?: boolean;
}) {
    const query = new URLSearchParams({ kind: input.kind, title: input.title, id: input.id, paid: input.paid ? "1" : "0" });
    if (input.start) query.set("start", input.start);
    if (input.end) query.set("end", input.end);
    return `/enrollment/success?${query.toString()}`;
}
